/**
 * Export `absoluteUrlResolve` util.
 */

export function absoluteUrlResolve(path: string): string {
  return new URL(path, process.env.NEXT_PUBLIC_BASE_URL).href;
}
